webpackJsonp([212839066777427],{

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogCard = function BlogCard(_ref) {
	  var post = _ref.post;
	  return _react2.default.createElement(
	    _styles.BlogPostCard,
	    null,
	    _react2.default.createElement(
	      _styles.BlogTitle,
	      null,
	      post.node.frontmatter.title
	    ),
	    _react2.default.createElement(
	      _styles.BlogDescription,
	      null,
	      post.node.frontmatter.description
	    ),
	    _react2.default.createElement(
	      _styles.BlogAuthorDetails,
	      null,
	      post.node.frontmatter.author,
	      _react2.default.createElement(
	        'span',
	        null,
	        ' | '
	      ),
	      post.node.frontmatter.date
	    ),
	    _react2.default.createElement(
	      _styles.BlogTagIcons,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Tags | '
	      ),
	      post.node.frontmatter.tags.map(function (icon, i) {
	        return _react2.default.createElement(
	          'p',
	          { key: i },
	          icon
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _styles.BlogReadLink,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: post.node.frontmatter.path },
	        ' Read '
	      )
	    )
	  );
	};
	
	BlogCard.propTypes = {
	  post: _propTypes2.default.object.isRequired
	};
	
	exports.default = BlogCard;
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BlogReadLink = exports.BlogTagIcons = exports.BlogAuthorDetails = exports.BlogDescription = exports.BlogTitle = exports.BlogPostCard = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  min-height: 220px;\n  min-width: 50%;\n  box-shadow: 0px 0px 8px #b3b3b3;\n  border-radius: 2px;\n  transition: .1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fff;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  transition: all cubic-bezier(.42,.16,.26,1.4) 400ms;\n  margin-bottom: 14px;\n  position: relative;\n  animation: .5s ease ', ' forwards;\n\n    & > p {\n      width: 80%;\n    }\n    \n    &:hover {\n      transition: all cubic-bezier(.42,.16,.26,1.4) 200ms;\n      box-shadow: 0px 0px 12px #a1bede;\n      transform: translateY(-1px);\n    }\n\n    ', '\n'], ['\n  min-height: 220px;\n  min-width: 50%;\n  box-shadow: 0px 0px 8px #b3b3b3;\n  border-radius: 2px;\n  transition: .1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fff;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  transition: all cubic-bezier(.42,.16,.26,1.4) 400ms;\n  margin-bottom: 14px;\n  position: relative;\n  animation: .5s ease ', ' forwards;\n\n    & > p {\n      width: 80%;\n    }\n    \n    &:hover {\n      transition: all cubic-bezier(.42,.16,.26,1.4) 200ms;\n      box-shadow: 0px 0px 12px #a1bede;\n      transform: translateY(-1px);\n    }\n\n    ', '\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      min-width: 80%;\n    '], ['\n      min-width: 80%;\n    ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-size: 1.4em;\n  color: #020202;\n  font-weight: 700;\n  margin-top: -5px;\n\n'], ['\n  font-size: 1.4em;\n  color: #020202;\n  font-weight: 700;\n  margin-top: -5px;\n\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: .75em;\n  margin-top: -5px;\n  letter-spacing: .2px;\n'], ['\n  font-size: .75em;\n  margin-top: -5px;\n  letter-spacing: .2px;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: .6em;\n  color: #999999;\n  text-align: right;\n  letter-spacing: .1px;\n\n  & > span {\n    font-size: 1em;\n  }\n'], ['\n  font-size: .6em;\n  color: #999999;\n  text-align: right;\n  letter-spacing: .1px;\n\n  & > span {\n    font-size: 1em;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n\n  & > p {\n    margin-right: 6px;\n    color: #999999;\n    font-weight: 400;\n    letter-spacing: .1px;\n    font-size: .5em;\n  }\n\n  & img {\n    margin-left: 10px;\n    width: 16px;\n  }\n'], ['\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n\n  & > p {\n    margin-right: 6px;\n    color: #999999;\n    font-weight: 400;\n    letter-spacing: .1px;\n    font-size: .5em;\n  }\n\n  & img {\n    margin-left: 10px;\n    width: 16px;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  bottom: 18px;\n  cursor: pointer;\n\n  & > a {\n    text-decoration: none;\n    font-size: .8em;\n    font-weight: 500;\n    color: #020202;\n    transition: .2s;\n\n    &:hover {\n      color: #3a6ea5;\n      transition: .2s;\n    }\n  }\n'], ['\n  position: absolute;\n  bottom: 18px;\n  cursor: pointer;\n\n  & > a {\n    text-decoration: none;\n    font-size: .8em;\n    font-weight: 500;\n    color: #020202;\n    transition: .2s;\n\n    &:hover {\n      color: #3a6ea5;\n      transition: .2s;\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactAnimations = __webpack_require__(20);
	
	var _cssMediaTemplate = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var fadeUp = (0, _styledComponents.keyframes)(_templateObject, _reactAnimations.fadeInUp);
	
	var BlogPostCard = exports.BlogPostCard = _styledComponents2.default.div(_templateObject2, fadeUp, _cssMediaTemplate.media.medium(_templateObject3));
	
	var BlogTitle = exports.BlogTitle = _styledComponents2.default.p(_templateObject4);
	
	var BlogDescription = exports.BlogDescription = _styledComponents2.default.p(_templateObject5);
	
	var BlogAuthorDetails = exports.BlogAuthorDetails = _styledComponents2.default.p(_templateObject6);
	
	var BlogTagIcons = exports.BlogTagIcons = _styledComponents2.default.div(_templateObject7);
	
	var BlogReadLink = exports.BlogReadLink = _styledComponents2.default.div(_templateObject8);

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterSocial = function FooterSocial() {
	  return _react2.default.createElement(
	    _styles.FooterContainer,
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.github.com/maisonm', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        {
	          id: 'Layer_1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: '24',
	          height: '24',
	          viewBox: '0 0 24 24'
	        },
	        _react2.default.createElement('path', {
	          className: 'st0',
	          d: 'M12,0C5.4,0,0,5.4,0,12c0,5.3,3.4,9.8,8.2,11.4C8.8,23.5,9,23.1,9,22.8v-2.2c-3.3,0.7-4-1.4-4-1.4\tc-0.5-1.4-1.3-1.8-1.3-1.8c-1.1-0.7,0.1-0.7,0.1-0.7c1.2,0.1,1.8,1.2,1.8,1.2c1.1,1.8,2.8,1.3,3.5,1c0.1-0.8,0.4-1.3,0.8-1.6\tC7.1,17,4.3,16,4.3,11.4c0-1.3,0.5-2.4,1.2-3.2C5.5,7.9,5,6.6,5.7,5c0,0,1-0.3,3.3,1.2c1-0.3,2-0.4,3-0.4c1,0,2,0.1,3,0.4\tC17.3,4.7,18.3,5,18.3,5c0.7,1.7,0.2,2.9,0.1,3.2c0.8,0.8,1.2,1.9,1.2,3.2c0,4.6-2.8,5.6-5.5,5.9c0.4,0.4,0.8,1.1,0.8,2.2v3.3\tc0,0.3,0.2,0.7,0.8,0.6C20.6,21.8,24,17.3,24,12C24,5.4,18.6,0,12,0z'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.linkedin.com/in/maisonmoa', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z' })
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.twitter.com/maison_moa', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z' })
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.instagram.com/maison_m', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        {
	          id: 'Layer_1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: '24',
	          height: '24',
	          viewBox: '0 0 24 24'
	        },
	        _react2.default.createElement('path', {
	          className: 'st0',
	          d: 'M12,2.2c3.2,0,3.6,0,4.9,0.1c3.3,0.1,4.8,1.7,4.9,4.9c0.1,1.3,0.1,1.6,0.1,4.8s0,3.6-0.1,4.8\tc-0.1,3.2-1.7,4.8-4.9,4.9c-1.3,0.1-1.6,0.1-4.9,0.1c-3.2,0-3.6,0-4.8-0.1c-3.3-0.1-4.8-1.7-4.9-4.9c-0.1-1.3-0.1-1.6-0.1-4.8\ts0-3.6,0.1-4.8C2.4,4,4,2.4,7.2,2.3C8.4,2.2,8.8,2.2,12,2.2z M12,0C8.7,0,8.3,0,7.1,0.1c-4.4,0.2-6.8,2.6-7,7C0,8.3,0,8.7,0,12\ts0,3.7,0.1,4.9c0.2,4.4,2.6,6.8,7,7C8.3,24,8.7,24,12,24s3.7,0,4.9-0.1c4.4-0.2,6.8-2.6,7-7C24,15.7,24,15.3,24,12s0-3.7-0.1-4.9\tc-0.2-4.4-2.6-6.8-7-7C15.7,0,15.3,0,12,0z M12,5.8c-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2S15.4,5.8,12,5.8z M12,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S14.2,16,12,16z M18.4,4.2c-0.8,0-1.4,0.6-1.4,1.4S17.6,7,18.4,7s1.4-0.6,1.4-1.4\tS19.2,4.2,18.4,4.2z'
	        })
	      )
	    )
	  );
	};
	
	// Styles
	exports.default = FooterSocial;
	module.exports = exports['default'];

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LinkSvg = exports.FooterContainer = exports.SiteLink = exports.NavLinksContainer = exports.Bar = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 100%;\n  height: 55px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 0 4px #020202;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: 10px;\n  z-index: 99;\n  background: #fff;\n  position: relative;\n  /* This is the navbar logo home link wrapped in gatsby-link */\n  & > a {\n    display: flex;\n    align-items: center;\n  }\n'], ['\n  max-width: 100%;\n  height: 55px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 0 4px #020202;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: 10px;\n  z-index: 99;\n  background: #fff;\n  position: relative;\n  /* This is the navbar logo home link wrapped in gatsby-link */\n  & > a {\n    display: flex;\n    align-items: center;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ', ';\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  margin: 6px;\n\n  & > a {\n    text-decoration: none;\n    font-size: 0.8em;\n    font-weight: 500;\n    transition: 0.3s;\n    color: #020202;\n\n    &:hover {\n      color: #3a6ea5;\n      transition: 0.3s;\n      letter-spacing: 0.2px;\n    }\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin: 6px;\n\n  & > a {\n    text-decoration: none;\n    font-size: 0.8em;\n    font-weight: 500;\n    transition: 0.3s;\n    color: #020202;\n\n    &:hover {\n      color: #3a6ea5;\n      transition: 0.3s;\n      letter-spacing: 0.2px;\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  bottom: 18px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n  animation: 1.5s ease-in ', ' forwards;\n  animation-delay: 1.5s;\n'], ['\n  position: fixed;\n  bottom: 18px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n  animation: 1.5s ease-in ', ' forwards;\n  animation-delay: 1.5s;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  transition: 0.2s;\n  margin-left: 16px;\n  margin-right: 16px;\n\n  &:hover {\n    fill: #3a6ea5;\n    transition: 0.2s;\n  }\n'], ['\n  transition: 0.2s;\n  margin-left: 16px;\n  margin-right: 16px;\n\n  &:hover {\n    fill: #3a6ea5;\n    transition: 0.2s;\n  }\n']);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactAnimations = __webpack_require__(20);
	
	var _cssMediaTemplate = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var slideUp = (0, _styledComponents.keyframes)(_templateObject, _reactAnimations.bounceInUp);
	
	var Bar = exports.Bar = _styledComponents2.default.div(_templateObject2);
	
	var NavLinksContainer = exports.NavLinksContainer = _styledComponents2.default.div(_templateObject3, _cssMediaTemplate.media.medium(_templateObject4));
	
	var SiteLink = exports.SiteLink = _styledComponents2.default.div(_templateObject5);
	
	var FooterContainer = exports.FooterContainer = _styledComponents2.default.div(_templateObject6, slideUp);
	
	var LinkSvg = exports.LinkSvg = _styledComponents2.default.svg(_templateObject7);

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BlogListQuery = undefined;
	exports.default = Blog;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styles = __webpack_require__(278);
	
	var _BlogCard = __webpack_require__(262);
	
	var _BlogCard2 = _interopRequireDefault(_BlogCard);
	
	var _FooterSocial = __webpack_require__(27);
	
	var _FooterSocial2 = _interopRequireDefault(_FooterSocial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	function Blog(_ref) {
	  var data = _ref.data;
	  var post = data.allMarkdownRemark;
	
	  var BlogPost = post.edges.map(function (blog, i) {
	    return _react2.default.createElement(_BlogCard2.default, { key: i, post: blog });
	  });
	
	  return _react2.default.createElement(
	    _styles.BlogPostsPageContainer,
	    null,
	    _react2.default.createElement(
	      _styles.BlogCardContainer,
	      null,
	      BlogPost
	    ),
	    _react2.default.createElement(_FooterSocial2.default, null)
	  );
	}
	
	// Styled Components
	
	
	Blog.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	var BlogListQuery = exports.BlogListQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BlogCardContainer = exports.BlogPostsPageContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100vh;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  z-index: -99;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #FBFAFC;\n  background-image: url("data:image/svg+xml,%3Csvg width=\'52\' height=\'26\' viewBox=\'0 0 52 26\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%233a6ea5\' fill-opacity=\'.1\'%3E%3Cpath d=\'M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z\' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");\n'], ['\n  height: 100vh;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  z-index: -99;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #FBFAFC;\n  background-image: url("data:image/svg+xml,%3Csvg width=\'52\' height=\'26\' viewBox=\'0 0 52 26\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%233a6ea5\' fill-opacity=\'.1\'%3E%3Cpath d=\'M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z\' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 75%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  justify-content: center;\n  align-items: center;\n  padding: 6px;\n'], ['\n  height: 75%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  justify-content: center;\n  align-items: center;\n  padding: 6px;\n']);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BlogPostsPageContainer = exports.BlogPostsPageContainer = _styledComponents2.default.div(_templateObject);
	
	var BlogCardContainer = exports.BlogCardContainer = _styledComponents2.default.div(_templateObject2);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-4b88a524d15f29b9ed2c.js